import ChartLabel from './ChartLabel'

export default ChartLabel
